export type TimelinePointerEvent = {
  locationX?: number;
  offsetX?: number;
};

export function clampMediaTime(seconds: number, duration: number): number | null {
  if (!Number.isFinite(seconds)) return null;
  const safeDuration = Number.isFinite(duration) && duration > 0 ? duration : 0;
  return Math.max(0, Math.min(safeDuration, seconds));
}

export function resolveTimelinePointerX(
  event: TimelinePointerEvent,
  width: number,
  fallback?: number,
): number | null {
  if (!Number.isFinite(width) || width <= 0) return null;
  const candidate = Number.isFinite(event.locationX)
    ? event.locationX
    : Number.isFinite(event.offsetX)
      ? event.offsetX
      : fallback;
  if (!Number.isFinite(candidate)) return null;
  return Math.max(0, Math.min(width, candidate as number));
}

export function timelinePointerToSeconds(
  event: TimelinePointerEvent,
  width: number,
  duration: number,
  fallback?: number,
): number | null {
  const x = resolveTimelinePointerX(event, width, fallback);
  if (x === null || !Number.isFinite(duration) || duration <= 0) return null;
  return clampMediaTime((x / width) * duration, duration);
}
